// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TmcColumnCountByClass, ITmcColumnCountByClass } from "./Reports.TmcColumnCountByClass.gen";

export interface ITurningMovementCountByClassV2 {
	startTime: string | undefined;

	counts: ITmcColumnCountByClass[] | undefined;

	$type?: string | undefined;
}
export class TurningMovementCountByClassV2 {
	constructor(data?: ITurningMovementCountByClassV2) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.startTime) { this.startTime = new Date(data.startTime); }
		this.counts = data.counts ? data.counts.map((c: any) => new TmcColumnCountByClass(c)) : [];
	}

	startTime: Date | undefined;

	counts: TmcColumnCountByClass[] | undefined = [];

	static $type: string = "CoreApi.Models.Reports.TurningMovementCountByClassV2, ";
	$type?: string | undefined = TurningMovementCountByClassV2.$type;
}

